export default __webpack_public_path__ + "static/pragicts-partnerships-banner-global-partnerships-ea1edca36a4b6e9f006fd64f248f2be2.jpg";